<template>
  <div class="about">
    <div class="flex space-x-4">
      <button @click="counterStore.increment()"
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
        increment
      </button>
      <button @click="counterStore.resetCount()"
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">reset
      </button>
    </div>
    <h1>{{ counterStore.count }}</h1>
  </div>
</template>
<script setup>
import {useCounterStore} from "@/stores/counter.js";
const counterStore = useCounterStore();
</script>
<style>

</style>
